import lang from "./lang";
import { foundation } from "@teaming/slice-engine";

/*
	This is the main factory function for the app slice, a.k.a. - appleSlice.
*/
export function appleSlice() {
	const { registerTranslations, registerComponents, } = foundation();

	// wire up i18n messages
	registerTranslations( lang );

	// finally, init our globally available components
	registerComponents( {
		Callback: require( "./components/Callback" ),
		Loading: require( "./components/Loading" ),
		SignUp: require( "./components/SignUp" ),
		SignIn: require( "./components/SignIn" ),
		ZoomOauthCallback: require( "./components/ZoomOauthCallback" ),
	} );
}
